import { render, staticRenderFns } from "./DashboardAgent.vue?vue&type=template&id=c1515a68"
import script from "./DashboardAgent.vue?vue&type=script&lang=js"
export * from "./DashboardAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports